function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
var baseArrowStyle = {
  position: "absolute",
  width: "50px",
  height: "50px",
  backgroundColor: "rgba(0,0,0,0.5)",
  top: "50%",
  transform: "translateY(-50%)",
  borderRadius: "50%",
  color: "#fff",
  fontSize: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer"
};

var Arrow = _ref => {
  var {
    left = false,
    children,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    style: _extends({}, baseArrowStyle, {
      left: left ? "20px" : "initial",
      right: !left ? "10px" : "initial"
    })
  }, children);
};

export default Arrow;